import React from 'react';
import { useSelector } from 'react-redux';

import OpenTaskDetailsMenuItem from './OpenTaskDetailsMenuItem';
import EditTaskMenuItem from './EditTaskMenuItem';
import DeleteTaskMenuItem from './DeleteTaskMenuItem';
import MarkCompleteTaskMenuItem from './MarkCompleteTaskMenuItem';
import CopyTaskMenuItem from './CopyTaskMenuItem';

const TaskContextMenu = ({ taskId, setIsEdit, isWorkspaceTasksScreen = false, hasTaskDeleteRights = false }) => {
  return [
    {
      key: `TaskContextMenu-${taskId}-1`,
      label: <CopyTaskMenuItem taskId={taskId} />,
    },
    {
      key: `TaskContextMenu-${taskId}-2`,
      label: isWorkspaceTasksScreen ? (
        <EditTaskMenuItem handleClick={setIsEdit} taskId={taskId} />
      ) : (
        <OpenTaskDetailsMenuItem taskId={taskId} />
      ),
    },
    {
      key: `TaskContextMenu-${taskId}-3`,
      label: <MarkCompleteTaskMenuItem taskId={taskId} />,
    },
    // {
    //   key: `TaskContextMenu-${taskId}-4`,
    //   label: <FormattedMessage id="DUPLICATE_TASK" defaultMessage="Duplicate Task" />,
    //   onClick: () => dispatch(duplicateTaskAction(taskId));
    //   }
    // },
    (hasTaskDeleteRights && {
      key: `TaskContextMenu-${taskId}-5`,
      label: <DeleteTaskMenuItem taskId={taskId} />,
    }),
  ];
}

export default TaskContextMenu;
